import { render, staticRenderFns } from "./Processando.vue?vue&type=template&id=23ddad22&scoped=true&"
import script from "./Processando.vue?vue&type=script&lang=js&"
export * from "./Processando.vue?vue&type=script&lang=js&"
import style0 from "./Processando.vue?vue&type=style&index=0&id=23ddad22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ddad22",
  null
  
)

export default component.exports